import React from 'react';
import { useNavigate } from 'react-router-dom';
import PreferencesSettings from './PreferencesSettings';


export default function PreferencesSettingsNav(props) {
    let navigate = useNavigate();
    return <PreferencesSettings navigate={navigate}/>
}
